module.exports = __webpack_public_path__ + "img/4f_r_sanko_1.01a9f4f8.png";